<template>
<div
  class='hs-menu flex-v'
  :class='[menuExpanded ? "is-expanded" : "is-collapsed"]'
  :style="{ width: menuWidth + 'px', background: backgroundColor }"
>
  <slot name="logo" v-if="showLogo">
    <div class="logo flex-v" @click="logoClick" :class="{ 'is-expanded': menuExpanded }"></div>
  </slot>
  <el-select
    class="flex-item search-bar flex" v-show="menuExpanded"
    v-model="currentMenu"
    placeholder=" "
    default-first-option
    filterable
    popper-class="menu-select-popper"
    @change="to"
  >
    <i slot="prefix" class="HSIconfont hs-icon-search"></i>
    <el-option
      v-for="menu in menus"
      :key="menu.id"
      :value="menu.id"
      :label="menu.name ? t(menu.name) : menu.rawName"
    >
    </el-option>
  </el-select>

  <el-popover
    v-show="!menuExpanded"
    placement="right-start"
    popper-class="search-bar-popper"
    :style="{ background: backgroundColor }"
    :visible-arrow="false"
    :offset="0"
  >
    <div slot="reference" class="search-bar-2"><i class="HSIconfont hs-icon-search"></i></div>
    <el-select
      v-model="currentMenu"
      placeholder=" "
      default-first-option
      filterable
      popper-class="menu-select-popper"
      @change="to"
    >
      <i slot="prefix" class="HSIconfont hs-icon-search"></i>
      <el-option
        v-for="menu in menus"
        :key="menu.id"
        :value="menu.id"
        :label="menu.name ? t(menu.name) : menu.rawName"
      >
      </el-option>
    </el-select>
  </el-popover>

  <el-menu
    class="flex-main"
    :background-color="backgroundColor"
    :text-color="textColor"
    :active-text-color="activeTextColor"
    :collapse="!menuExpanded"
    :collapse-transition="false"
    :default-active="defaultActiveMenu"
    :default-openeds="defaultOpeneds"
  >
    <menu-item
      v-for='menu in data'
      :menu='menu'
      :key='menu.id'
      @changeMenu="toMenu"
    />
  </el-menu>

  <div class='flex-item hs-menu__toggle-bar' @click='toggle'>
    <span :class='`el-icon-d-arrow-${ menuExpanded ? "left" : "right" }`'></span>
  </div>

  <div class="hs-menu-resizer" @mousedown="resize"></div>
</div>
</template>

<script>
import MenuItem from './menuItem.vue'
import Locale from '../../mixins/locale'

export default {
  name: 'HsMenu',
  mixins: [Locale],
  props: {
    /**
     * 是否显示的logo，默认为true
     */
    showLogo: {
      type: Boolean,
      default: true
    },
    /**
     * Menu数组；
     * interface Menu {
     *    type: 'path' | 'name' | 'link' // 菜单类型，默认: path;
     *    id: string | number; // 路由地址
     *    name?: string;       // 菜单名称
     *    rawName?: string;    // 无需翻译的菜单名称
     *    icon?: string;       // 菜单图标
     *    children?: Menu[]    // 子菜单
     * }
     */
    data: Array,
    /**
     * 默认选中菜单
     */
    defaultActive: {
      type: String
    },
    /**
     * 菜单宽度
     */
    width: {
      type: Number,
      default: 230
    },
    /**
     * 是否展开菜单
     */
    expanded: {
      type: Boolean,
      default: true
    },
    /**
     * 点击logo事件
     */
    logoClick: {
      type: Function,
      default: () => {}
    },
    /**
     * 菜单背景颜色
     */
    backgroundColor: {
      type: String,
      default: '#015AC5'
    },
    /**
     * 文字颜色
     */
    textColor: {
      type: String,
      default: '#fff'
    },
    /**
     * 激活状态文字颜色
     */
     activeTextColor: {
      type: String,
      default: '#015AC5'
     },
     /**
      * 默认展开
      */
    defaultOpeneds: {
      type: Array,
      default: () => []
    }
  },
  components: {
    MenuItem,
  },
  data() {
    return {
      menus: [],
      defaultActiveMenu: this.defaultActive,
      menuExpanded: this.expanded,
      currentMenu: '',
      menuWidth: this.width,
      orgWidth: Math.max(this.width, 160)
    }
  },
  methods: {
    getLeafMenus () {
      const menus = []
      const iterator = ms => {
        ms.forEach(m => {
          if (m.children?.length > 0) {
            iterator(m.children)
          } else {
            menus.push(m)
          }
        })
      }
      iterator(this.data)
      return menus
    },
    toggle() {
      this.menuExpanded = !this.menuExpanded
      if (!this.menuExpanded) {
        this.menuWidth = 64
      } else {
        this.menuWidth = this.orgWidth === 160 ? 230 : this.orgWidth
      }
      /**
       * 菜单展开或者收起时触发，事件参数返回菜单展开状态
       */
      this.$emit('resize', this.menuWidth)
      this.$emit('toggle', this.menuExpanded)
    },

    resize(e) {
      const orgWidth = this.menuWidth
      const orgX = e.pageX
      const drag = e => {
        const orgExpanded = this.menuExpanded
        this.menuWidth = Math.max(64, Math.min(orgWidth + e.pageX - orgX, 440))
        this.menuExpanded = this.menuWidth > 160
        if (orgExpanded !== this.menuExpanded) this.$emit('toggle', this.menuExpanded)
        /**
         * 鼠标移到菜单有边缘，拖拽调整菜单宽度，事件参数为菜单宽度
         */
        this.$emit('resize', this.menuWidth)
      }
      const dragEnd = () => {
        this.orgWidth = Math.max(160, this.menuWidth)
        if (!this.menuExpanded) {
          this.menuWidth = 64
          this.$emit('resize', this.menuWidth)
        }
        document.body.removeEventListener('mousemove', drag)
        document.body.removeEventListener('mouseleave', dragEnd)
        document.body.removeEventListener('mouseup', dragEnd)
        /**
         * 拖拽调整宽度结束事件，事件参数为菜单宽度
         */
        this.$emit('resizeEnd', this.menuWidth)
      }

      document.body.addEventListener('mousemove', drag)
      document.body.addEventListener('mouseleave', dragEnd)
      document.body.addEventListener('mouseup', dragEnd)
    },
    to (v) {
      this.currentMenu = ''
      const menu = this.menus.find(m => m.id === v)
      menu && this.toMenu(menu)
    },
    toMenu (menu) {
      const _defaultActiveMenu = this.defaultActiveMenu
      const { type, id } = menu
      if (type === 'link') {
        window.open(id)
        this.defaultActiveMenu = ''
        this.$nextTick(() => this.defaultActiveMenu = _defaultActiveMenu)
      } else if (type === 'name') {
        this.$router && this.$router.push({ name: id })
        this.defaultActiveMenu = id
      } else {
        this.$router && this.$router.push({ path: id })
        this.defaultActiveMenu = id
      }
    }
  },
  watch: {
    data: {
      handler () {
        this.menus = this.getLeafMenus()
      },
      immediate: true
    }, 
    expanded(v) {
      this.menuExpanded = v
    },
    width(v) {
      this.menuWidth = v
    },
    defaultActive (v) {
      this.defaultActiveMenu = v
    }
  }
}
</script>

<style scoped lang='scss'>
.hs-menu {
  position: relative;
  height: 100%;
  user-select: none;
}

.hs-menu .logo {
  height: 50px;
  background-image: url(../../assets/logo2.png);
  background-size: 25px 25px;
  background-position: center center;
  background-repeat: no-repeat;
}
.hs-menu .logo.is-expanded {
  background-image: url(../../assets/logo.png);
  background-size: 140px 25px;
  background-position: 25px center;
}

.el-menu {
  width: 100%;
  box-sizing: border-box;
  border-right: none !important;
}
.hs-menu__toggle-bar {
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-top: 1px solid rgba(255,255,255,.3)
}

.hs-menu-resizer {
  position: absolute;
  top: 0;
  right: -5px;
  bottom: 0;
  width: 10px;
  cursor: col-resize;
}
.search-bar-2 {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
</style>

<style lang="scss">
.hs-menu .el-menu,
.el-menu.el-menu--popup {
  border: none;
  padding: 0 4px;
}
.el-menu .el-menu {
  padding: 0;
}
.el-submenu__title,
.el-submenu .el-menu-item,
.el-menu .el-menu-item {
  height: 38px;
  line-height: 35px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: auto;
}
.el-submenu + .el-submenu,
.el-menu-item + .el-menu-item {
  margin-top: 4px;
}
.hs-menu.is-expanded .el-submenu__title {
  padding-right: 30px;
}
.el-menu-item.is-active {
  background-color: #fff !important;
}
.el-menu--collapse .el-submenu > .el-submenu__title,
.el-menu--collapse .el-menu-item {
  text-align: center;
  padding: 0 !important;
  span {
    display: none;
  }
}
.el-menu.el-menu--popup {
  padding: 4px;
}
.hs-menu .search-bar {
  margin: 10px 8px;
  width: auto;
  border-radius: 4px;
  .el-input__inner {
    height: 30px;
    border: none;
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
    padding-left: 30px;
    &::placeholder {
      color: #fff;
      opacity: 0.8;
    }
  }
  .el-select__caret {
    display: none;
  }
  .el-input__prefix {
    padding: 0 6px;
    line-height: 30px;
    font-size: 12px;
    color: #fff;
  }
}
.menu-select-popper {
  border-radius: 10px;
  .popper__arrow {
    display: none;
  }
}
.search-bar-popper.el-popper[x-placement^=right] {
  margin-left: 1px;
}
.search-bar-popper .el-input__inner {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
.search-bar-popper .el-input__prefix {
  line-height: 30px;
}
.el-submenu .el-submenu__title .el-submenu__icon-arrow {
  color: #fff;
}
.hs-menu.is-collapsed .el-submenu .el-submenu__title .el-submenu__icon-arrow {
  color: transparent;
}
.el-submenu__title,.el-menu-item{
  span{
    margin-left: 5px;
  }
}
.el-submenu .el-menu-item{
span{
    margin-left: 1px;
  }
}
.hs-menu .hs-icon-search {
  font-size: 20px;
}
</style>